"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInvitationSchema = void 0;
const zod_1 = require("zod");
const roles_1 = require("../roles");
/**
 * Create-invitation request body.
 *  - `email` — trimmed, lowercased, RFC-5322.
 *  - `userRole` — single role from the shared catalog.
 *  - `approverRoles` — optional multi-select; defaults to `[]`.
 */
exports.createInvitationSchema = zod_1.z.object({
    email: zod_1.z.string().trim().toLowerCase().email('Enter a valid email.'),
    userRole: roles_1.appRoleSchema,
    approverRoles: zod_1.z.array(roles_1.appRoleSchema).default([]),
});
//# sourceMappingURL=create-invitation.schema.js.map